<template>
  <RevContentBlock
    class="px-48"
    :image-props="{
      alt: i18n(translations.description),
      height: 257,
      src: '/img/empty.svg',
      width: 465,
    }"
    :surtitle="i18n(translations.description)"
    :title="i18n(translations.title)"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContentBlock } from '@ds/components/ContentBlock'

import translations from './NoResults.translations'

const i18n = useI18n()
</script>
